import AIOrb from '@src/components/Common/AIOrb';

interface AIBubbleProps {
  isTalking?: boolean;
  isListening?: boolean;
  onClick: () => void;
}

const AIBubble: React.FC<AIBubbleProps> = ({
  isTalking = false,
  isListening = false,
  onClick,
}) => (
  <div style={{ width: 40, height: 32, position: 'relative' }}>
    <div
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-label="AI assistant"
      onKeyDown={(e: React.KeyboardEvent) => e.key === 'Enter' && onClick()}
      style={{
        cursor: 'pointer',
        outline: 'none',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      }}
    >
      <AIOrb
        isTalking={isTalking}
        isListening={isListening}
        size={42}
        iconSize={40}
      />
    </div>
  </div>
);

export default AIBubble;
